/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiKey } from '../models/ApiKey';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ApiKeyService {
    /**
     * List API keys
     * @returns ApiKey Successfully listed API keys
     * @throws ApiError
     */
    public static getApiKey(): CancelablePromise<ApiKey> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api-key',
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * Add a API key
     * @param requestBody
     * @returns ApiKey Successfully added API key
     * @throws ApiError
     */
    public static postApiKey(
        requestBody: {
            name?: string;
        },
    ): CancelablePromise<ApiKey> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api-key',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * Delete API key
     * @param id The id of api key
     * @returns any Successfully deleted api key
     * @throws ApiError
     */
    public static deleteApiKey(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api-key/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Api key not found`,
                500: `Internal server error`,
            },
        });
    }
}
